module.exports = __webpack_public_path__ + "static/media/AtlasGrotesk-Bold-Cy-Web.dc2b1810.woff";